import { Reveal, SectionHead } from "@/components/Reveal";
import { RELIABILITY_CHECKLIST } from "@/data/content";
import { CheckCircle2 } from "lucide-react";

const FloorPlan = () => (
  <svg viewBox="0 0 320 220" className="w-full rounded-2xl border border-white/10 bg-[#090D10]" role="img" aria-label="Plattegrond met detectiezones en een pulserend alarmgebied">
    <rect x="14" y="14" width="292" height="192" fill="none" stroke="#2B9FD7" strokeOpacity="0.35" strokeWidth="1.5" />
    <line x1="120" y1="14" x2="120" y2="206" stroke="#2B9FD7" strokeOpacity="0.2" className="tech-line" />
    <line x1="14" y1="120" x2="306" y2="120" stroke="#2B9FD7" strokeOpacity="0.2" className="tech-line" />
    <rect x="26" y="26" width="82" height="82" fill="#2B9FD7" fillOpacity="0.08" stroke="#2B9FD7" strokeOpacity="0.3" />
    <text x="36" y="48" fill="#62C3F0" fontSize="9" fontFamily="Sora, sans-serif">ZONE 1</text>
    <rect x="26" y="132" width="82" height="62" fill="#2B9FD7" fillOpacity="0.08" stroke="#2B9FD7" strokeOpacity="0.3" />
    <text x="36" y="154" fill="#62C3F0" fontSize="9" fontFamily="Sora, sans-serif">ZONE 2</text>
    <rect x="134" y="132" width="160" height="62" fill="#2B9FD7" fillOpacity="0.08" stroke="#2B9FD7" strokeOpacity="0.3" />
    <text x="144" y="154" fill="#62C3F0" fontSize="9" fontFamily="Sora, sans-serif">ZONE 4 · TRANSPORTBAND</text>
    <rect x="134" y="26" width="160" height="82" fill="#E5483F" fillOpacity="0.14" stroke="#E5483F" strokeOpacity="0.6" className="alarm-zone" />
    <text x="144" y="48" fill="#E5483F" fontSize="9" fontFamily="Sora, sans-serif" fontWeight="700">ZONE 3 · VOORALARM</text>
    <circle cx="214" cy="72" r="5" fill="#FF8A00" className="hotspot-core" />
    <circle cx="214" cy="72" r="12" fill="none" stroke="#FF8A00" strokeOpacity="0.6" className="hotspot-ring" />
    <circle cx="300" cy="200" r="4" fill="#62C3F0" />
    <path d="M300,200 L262,168" stroke="#62C3F0" strokeOpacity="0.5" className="tech-line" />
  </svg>
);

export const Reliability = () => (
  <section className="py-24 md:py-36" data-testid="reliability-section">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10">
      <SectionHead nr="09" overline="Betrouwbaarheid" title="Een betrouwbaar systeem begint met een correct ontwerp" />
      <div className="mt-12 grid gap-12 lg:grid-cols-2 lg:gap-16">
        <div>
          <Reveal delay={0.1}>
            <p className="text-base leading-relaxed text-[#CBD3D9]">
              Een thermische camera is geen standaardproduct dat op iedere locatie op dezelfde manier
              functioneert. Afstand, kijkhoek, montagehoogte, materiaalsoort, omgevingswarmte,
              reflecties, weersinvloeden, vervuiling van de lens en zichtbelemmeringen kunnen invloed
              hebben op de meting.
            </p>
            <p className="mt-4 text-base leading-relaxed text-[#CBD3D9]">
              Daarom ontwerpen wij iedere oplossing op basis van de locatie en de daadwerkelijke
              risico's.
            </p>
          </Reveal>
          <ul className="mt-8 grid gap-3">
            {RELIABILITY_CHECKLIST.map((item, i) => (
              <Reveal key={item} delay={0.1 + i * 0.06}>
                <li className="flex items-center gap-3 text-sm font-medium text-[#F5F7F9]">
                  <CheckCircle2 size={17} className="shrink-0 text-[#2B9FD7]" /> {item}
                </li>
              </Reveal>
            ))}
          </ul>
        </div>
        <Reveal delay={0.2}>
          <FloorPlan />
          <div className="mt-6 rounded-xl border border-white/10 bg-[#10232F]/50 p-5">
            <p className="text-xs leading-relaxed text-[#CBD3D9]/75">
              Een thermisch camerasysteem is een vroegtijdige detectie- en waarschuwingsoplossing. Of
              het systeem onderdeel kan zijn van een formele brandveiligheidsvoorziening of
              brandmeldinstallatie, moet per locatie, risicoanalyse, verzekeraar en geldende
              regelgeving worden beoordeeld.
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
